export default __webpack_public_path__ + "static/media/KDB산업.43d14288.svg";